import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"pyramid"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M11 21L16.5 11L22 21H11Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M11 21H2L11 5L15.4494 12.9101L11 21Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M11 21H2L7.0625 12M11 21L13.75 16L15.4494 12.9101L14.9375 12M11 21V12M7.0625 12L11 5L14.9375 12M7.0625 12H11M14.9375 12H11","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M13.75 16L11 21H16.5M13.75 16H16.5M13.75 16L16.5 11L19.25 16M19.25 16L22 21H16.5M19.25 16H16.5M16.5 16V21","strokeWidth":"props.strokeWidth"}}]}]};

const Pyramid = Vue.extend<IconProps>({
  name: 'PyramidIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'pyramid',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Pyramid;
